import { render } from "./CoursesTable.vue?vue&type=template&id=0597d224&scoped=true"
import script from "./CoursesTable.vue?vue&type=script&lang=js"
export * from "./CoursesTable.vue?vue&type=script&lang=js"

import "./CoursesTable.vue?vue&type=style&index=0&id=0597d224&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0597d224"]])

export default __exports__